import React from 'react';
import { ToastProvider } from "./toast";
import { useToast } from "@/hooks/use-toast";

export function SimpleToaster() {
  const { toasts, dismiss } = useToast();

  // No need for custom timers anymore since use-toast.ts handles duration
  
  return (
    <div className="fixed top-0 right-0 z-50 p-4 space-y-4 max-w-md">
      {toasts.map(({ id, title, description, variant }) => (
        <div 
          key={id} 
          className={`p-4 rounded-lg shadow-lg transition-all transform translate-x-0 ${
            variant === 'destructive' 
              ? 'bg-red-600 text-white' 
              : 'bg-white text-gray-800 border border-gray-200'
          }`}
        >
          <div className="flex justify-between items-start">
            <div>
              {title && <p className="font-semibold">{title}</p>}
              {description && <p className="text-sm mt-1 opacity-90">{description}</p>}
            </div>
            <button 
              className="ml-4 text-sm opacity-70 hover:opacity-100 transition-opacity"
              onClick={() => dismiss(id)}
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
} 